"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCreateNewShareClassMethodRequest = exports.CreateNewShareClassSchema = void 0;
const yup = __importStar(require("yup"));
const ValidationError_1 = require("../errors/ValidationError");
const constants_1 = require("../constants");
const SetSharePriceSchema_1 = require("./SetSharePriceSchema");
/**
 * Schema for create new share class method validation
 * {@link ICreateNewShareClass}
 */
// Callers select the wording with `{ context: { isUnitRegistry: true } }`.
const classTerm = (isUnitRegistry) => (isUnitRegistry ? "unit class" : "share class");
const CreateNewShareClassSchema = yup.object().shape({
    name: yup.string().when("$isUnitRegistry", ([isUnitRegistry]) => yup
        .string()
        .trim()
        .transform((value) => (!value ? undefined : value))
        .required(`Please enter ${classTerm(isUnitRegistry)} name`)
        .max(60)
        .min(1)),
    code: yup.string().when("$isUnitRegistry", ([isUnitRegistry]) => yup
        .string()
        .trim()
        .transform((value) => (!value ? undefined : value))
        .required(`Please enter ${classTerm(isUnitRegistry)} code`)
        .matches(constants_1.ALPHANUMERIC_REGEX, `${isUnitRegistry ? "Unit" : "Share"} class code can only contain letters and numbers`)
        .max(4)
        .min(1)),
    sharePrice: SetSharePriceSchema_1.sharePriceSchema,
    subscriptionPrice: SetSharePriceSchema_1.subscriptionPriceSchema,
    redemptionPrice: SetSharePriceSchema_1.redemptionPriceSchema,
    effectiveFrom: SetSharePriceSchema_1.sharePriceEffectiveDateSchema,
});
exports.CreateNewShareClassSchema = CreateNewShareClassSchema;
/**
 * Validates create new share class method request schema
 * @param data: create new share class method request {@link ICreateNewShareClass} to validate
 * @param isUnitRegistry: when true the mandatory reference price is reported as the unit price rather
 * than the share price, matching the wording the operator sees on a unit fund
 */
const validateCreateNewShareClassMethodRequest = async (data, isUnitRegistry = false) => {
    try {
        await CreateNewShareClassSchema.validate(data, {
            abortEarly: false,
            context: { isUnitRegistry },
        });
    }
    catch (err) {
        if (err instanceof yup.ValidationError) {
            const errorMessage = err.errors.toString();
            throw new ValidationError_1.ValidationError(errorMessage);
        }
        else {
            throw err;
        }
    }
};
exports.validateCreateNewShareClassMethodRequest = validateCreateNewShareClassMethodRequest;
//# sourceMappingURL=CreateNewShareClass.js.map